import moment from "moment";
import {
  buttonNameConstants,
  buttonTypeConstants,
  EMPTY_STRING,
  FALSE_STRING,
  TRUE_STRING,
} from "../../constants";
import { getActionColumnOfReactDataTableComponent } from "./columnHeadersUtility";
import { Button, CustomTooltip } from "../components";
import {
  ActionDotsIcons,
  DeleteIcon,
  EditIcon,
} from "../../assets/icons/iconsProvider";

// compare string case incessitive
export const isStringEqual = (a, b) => {
  return typeof a === "string" && typeof b === "string"
    ? a.localeCompare(b, undefined, { sensitivity: "accent" }) === 0
    : a === b;
};

// remove duplicate values of array of string
export const getArrayUniqueValues = (arr) => {
  return [...new Set(arr)];
};

export const isDateOlderThanToday = (date) => {
  return new moment(date) < new moment();
};

export const stringToTitleCase = (str) => {
  if (!str) {
    return EMPTY_STRING;
  }
  return str.replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
};

// Returns select options for react-select component from an array of strings or a single string
export const handleCreateSelectOptions = (arrayOfStrings) => {
  return Array.isArray(arrayOfStrings)
    ? arrayOfStrings
        .map((item) => String(item))
        .filter((item) => item) //exclude null values
        .map((item) => ({
          value: item,
          label: item,
        }))
    : typeof arrayOfStrings === "string"
    ? { value: arrayOfStrings, label: arrayOfStrings }
    : arrayOfStrings;
};

// filter out null values as in col definations when we don't want to render columns we are returning null (i.e. getOutletColumn returns null, getBatchModalGradeColumn)
export const excludeNullColumns = (columns) => {
  return columns.filter(
    (column) =>
      column !== null &&
      column !== undefined &&
      column !== false &&
      column !== EMPTY_STRING
  );
};
export const toTitleCase = (str) => {
  return str.toLowerCase().replace(/\w\S*/g, function (text) {
    return text.charAt(0).toUpperCase() + text.substring(1);
  });
};

export const handleConvertStringBooleanIntoBoolean = (value) => {
  return typeof value === "boolean"
    ? value
    : String(value).toLowerCase() === TRUE_STRING
    ? true
    : String(value).toLowerCase() === FALSE_STRING
    ? false
    : false;
};

export const handleProductSaleTypeChange = (option, setFieldValue) => {
  setFieldValue("isSeparateQuantity", option);
};

export const getIsHideNonInventoryOptions = (store) => {
  return store.isHideNonInventoryOperations || false;
};

export const handleNumberSubmit = (value) => {
  let stringValue = String(value);
  if (
    stringValue.includes("null") ||
    stringValue.includes("NaN") ||
    stringValue.includes("undefined") ||
    stringValue.includes("NaN.undefined")
  ) {
    return 0;
  }
  return value;
};

export const handleIsInvalidInteger = (value) => {
  let stringValue = String(value);
  if (
    stringValue.includes("null") ||
    stringValue.includes("NaN") ||
    stringValue.includes("undefined") ||
    stringValue.includes("NaN.undefined") ||
    value === null ||
    value === undefined ||
    isNaN(value)
  ) {
    return true;
  }
  return false;
};

export const sum = (num1, num2) => {
  return Number(num1) + Number(num2);
};

export const getRandomNumber = () => {
  return crypto.randomUUID().replace(/-/g, "");
};

export const removeDuplicatesFromArrOfString = (arr) => [...new Set(arr)];

export const editDeleteActions = (handleEditClick, handleDeleteClick) =>
  getActionColumnOfReactDataTableComponent((row) => {
    return (
      <>
        <CustomTooltip anchorSelect={`#tool${row.id}`}>
          <Button
            label={buttonNameConstants.EDIT}
            className="w-100"
            buttonType={buttonTypeConstants.ACTION_BUTTON}
            IconImage={EditIcon}
            handleClick={() => handleEditClick(row)}
          />
          <Button
            label={buttonNameConstants.DELETE}
            className="w-100"
            type="button"
            buttonType={buttonTypeConstants.ACTION_BUTTON}
            IconImage={DeleteIcon}
            handleClick={() => handleDeleteClick(row.id)}
          />
        </CustomTooltip>
        <button id={`tool${row.id}`} className="action-Button-Wrapper">
          <ActionDotsIcons className="cursor-pointer" />
        </button>
      </>
    );
  });

// ToolTip ID helper: react-tooltip breaks if the element ID contains spaces (invalid CSS selector), so append a random suffix and remove all spaces to produce a valid ID.
export const getToolTipId = (id = EMPTY_STRING) => {
  return `id${id}${getRandomNumber()}`.replace(/[^a-zA-Z0-9]/g, EMPTY_STRING);
};

// Right now it only allows letter, number, ., -, _ and must not end with " "
export const validateDbDocumentId = (invoiceId) => {
  if (!invoiceId) return false;

  // reject trailing space explicitly
  if (invoiceId.endsWith(" ")) return false;

  return /^[a-zA-Z0-9 ._-]+$/.test(invoiceId);
};

export const getDate = (
  date,
  isConvertInUtc = true,
  isDefaultToday = true,
  isMmDdYyFormat = true
) => {
  let utcDate = null;
  if (date && isConvertInUtc) {
    utcDate = moment(date).utc();
  } else if (date && !isConvertInUtc && isMmDdYyFormat) {
    utcDate = moment(date, "MM/DD/YYYY").toDate();
  } else if (!date && isDefaultToday) {
    utcDate = moment().utc();
  }
  return utcDate;
};

export const resetReactRouterState = (navigate, location) => {
  navigate(location.pathname, { state: {} });
};
